/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Payment_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to open payment settings." |
*
* @param {Billing_Payment_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_payment_error = /** @type {((inputs?: Billing_Payment_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Payment_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlungseinstellungen konnten nicht geöffnet werden.")
	return /** @type {LocalizedString} */ ("Failed to open payment settings.")
});